import { Get, Post } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import ValidationResult from "domain/types/global/validationResult";
import { UltimaOperacaoResponse } from "../../types/aprovarPedido/ultimaOperacaoResponse";
import { BulkOperationResponse } from "../../types/aprovarPedido/bulkOperationResponse";

export class AprovarPedidoService {
  constructor() {
  }
  async AprovarPedido(campanhaPedidoResgateId: number, statusAtual: number, usuarioAprovador: string, empresaId: string, status: number, motivo: string): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.aprovarResgate, { campanhaPedidoResgateId, statusAtual, usuarioAprovador, empresaId, status, motivo })
  }

  async AprovarPedidoBulk(campanhaPedidoResgateIds: number[], usuarioAprovador: string, empresaId: number, status: number, motivo: string): Promise<BulkOperationResponse | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.aprovarResgateBulk, { campanhaPedidoResgateIds, usuarioAprovador, empresaId, status, motivo })
  }

  async ReprovarPedido(campanhaPedidoResgateId: number, motivo: string, usuario: string): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.reprovarResgate, { campanhaPedidoResgateId, motivo, usuario })
  }

  async ReprovarPedidoBulk(campanhaPedidoResgateIds: number[], motivo: string, usuario: string): Promise<BulkOperationResponse | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.reprovarResgateBulk, { campanhaPedidoResgateIds, motivo, usuario })
  }

  async GetUltimaOperacao(campanhaPedidoResgateId: number): Promise<UltimaOperacaoResponse | null> {
    const result = await Get<UltimaOperacaoResponse>(CampanhaConstants.apiCampanha.CampanhaPedidoResgate.ultimaOperacao(campanhaPedidoResgateId))
    if (result instanceof Error) {
      return null;
    }
    return result;
  }
}
